import * as React from 'react';
import { CustomSentenceApi, ICustomSentence } from "../api/CustomSentenceApi";

interface ICustomSentenceListContextType {
    customSentenceList: ICustomSentence[] | null;
    setCustomSentenceList: (newCustomSentenceList: ICustomSentence[]) => void;
    selectedSentence: ICustomSentence;
    setSelectedSentence: (newSentence: ICustomSentence) => void;
    refreshCustomSentenceList: () => void;
};

const CustomSentenceListInitialContext = {
    customSentenceList: null, setCustomSentenceList: () => null,
    selectedSentence: { id: 0, text: '', pinyin: [] }, setSelectedSentence: () => null,
    refreshCustomSentenceList: () => null,
};

const CustomSentenceListContext = React.createContext<ICustomSentenceListContextType>(CustomSentenceListInitialContext);
export default CustomSentenceListContext

export const CustomSentenceListProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [selectedSentence, setSelectedSentence] = React.useState<ICustomSentence>(CustomSentenceListInitialContext.selectedSentence);
    const [customSentenceList, setCustomSentenceList] = React.useState<ICustomSentence[] | null>(CustomSentenceListInitialContext.customSentenceList);

    const refreshCustomSentenceList = React.useCallback(() => {
        CustomSentenceApi.getAll()
            .then((response) => {
                if (response.status < 300) return response.data;
                return [];
            })
            .then((list) => {
                setCustomSentenceList(list);
            })
            .catch((err) => console.error("Failed to refresh sentence list", err));
    }, []);

    const contextValue = React.useMemo(() => ({
        selectedSentence,
        setSelectedSentence,
        customSentenceList,
        setCustomSentenceList,
        refreshCustomSentenceList,
    }), [selectedSentence, customSentenceList, refreshCustomSentenceList]);

    return (
        <CustomSentenceListContext.Provider value={contextValue}>
            {children}
        </CustomSentenceListContext.Provider>
    );
};